var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"surveyRef",staticClass:"box-survey",class:{'box-survey--pc': this.$platform.pc}})
}
var staticRenderFns = []

export { render, staticRenderFns }